import styled from '@emotion/styled';
import { Avatar, Box, Typography } from '@mui/material';

interface MainTitleProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  isMobile?: boolean
  component?: string;
}

export const MainTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "isMobile",
}) <MainTitleProps>`
  font-size: ${({ isMobile }) => (isMobile ? "1.4em" : "1.8em")};
`;

interface MainContainerProps {
  isMobile?: boolean;
}

export const MainContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isMobile",
}) <MainContainerProps>`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding-bottom: ${({ isMobile }) => (isMobile ? "16px" : "24px")};
`

export const BrawlersContainer = styled(Box)`
  padding-top: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
`

export const AvatarContainer = styled(Box)`
  padding: 4px;
  width: 112px;
  height: 112px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 8px;

  @media (min-width: 340px) and (max-width: 520px) {
    width: 26vw;
    height: 26vw;
  }
`

export const AvatarStyled = styled(Avatar)`
  height: 60px;
  width: 60px;
`

export const BrawlerName = styled(Typography)`
  text-shadow: 2px 2px black;
`